import * as AvatarPrimitive from '@radix-ui/react-avatar';
import * as React from 'react';

import { cn } from '@lib/utils';

const Avatar = (props: React.ComponentProps<typeof AvatarPrimitive.Root>) => {
  const { className, ...otherProps } = props;

  return (
    <AvatarPrimitive.Root
      className={cn('relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full', className)}
      {...otherProps}
    />
  );
};
Avatar.displayName = AvatarPrimitive.Root.displayName;

const AvatarImage = (props: React.ComponentProps<typeof AvatarPrimitive.Image>) => {
  const { className, ...otherProps } = props;

  return (
    <AvatarPrimitive.Image
      className={cn('aspect-square h-full w-full', className)}
      {...otherProps}
    />
  );
};
AvatarImage.displayName = AvatarPrimitive.Image.displayName;

const AvatarFallback = (props: React.ComponentProps<typeof AvatarPrimitive.Fallback>) => {
  const { className, ...otherProps } = props;

  return (
    <AvatarPrimitive.Fallback
      className={cn('flex h-full w-full items-center justify-center rounded-full bg-muted', className)}
      {...otherProps}
    />
  );
};
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;

export { Avatar, AvatarImage, AvatarFallback };
